import { Typography, MenuItem, TextField } from "@mui/material"
import { InputForm } from "@komune-io/g2-forms"// Helper to get enum name from Kotlin/JS enum objects
export const getEnumName = (value: any): string => {
  if (!value) return ""
  if (typeof value === "string") return value
  if (typeof value === "object" && value.id) return value.id
  if (typeof value === "object" && value.name) return value.name
  return String(value)
}

interface SelectFormFieldProps {
  label: string
  value: any
  labels: Record<string, string>
  onChange: (value: string) => void
  readOnly?: boolean
}

export const SelectFormField = (props: SelectFormFieldProps) => {
  const { label, value, labels, onChange, readOnly = false } = props
  const enumName = getEnumName(value)

  if (readOnly) {
    return (
      <InputForm
        inputType="textField"
        label={label}
        value={labels[enumName] || ""}
        readOnly
      />
    )
  }

  return (
    <>
      <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
        {label}
      </Typography>
      <TextField
        select
        fullWidth
        size="small"
        value={enumName}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">-</MenuItem>
        {Object.entries(labels).map(([key, optionLabel]) => (
          <MenuItem key={key} value={key}>{optionLabel}</MenuItem>
        ))}
      </TextField>
    </>
  )
}
